import {makeAutoObservable} from "mobx";
import {fromPromise} from "mobx-utils";
import {createChat} from "../../http/СhatAPI";
import {isObject, uniqBy} from "lodash";

export class ChatStore {
    sockets = {}
    messages = {}
    pendingMap = {}
    courseChatMap = {};

    constructor() {
        makeAutoObservable(this)
    }

    createChat = (courseId) => {
        this.courseChatMap[courseId] = fromPromise(createChat(courseId));
    }

    sendMessage = (chatId, message) => {
        if (!this.sockets[chatId]) return;

        const timestamp = new Date().toISOString();

        this.messages[chatId] = [
            ...this.messages[chatId],
            {isLocal: true, sender: 'user', message, timestamp, id: timestamp}
        ];
        this.sockets[chatId].send(JSON.stringify({message, type: 'text'}));
    }

    connect({chatId, userId, accessToken}) {
        if (this.sockets[chatId]) return;

        const socket = new WebSocket(`wss://backend.boost-ai.ru/ws/chats/chat/connect/${chatId}?accessToken=${accessToken}`);

        this.pendingMap[chatId] = true;
        this.sockets[chatId] = socket;

        socket.onopen = () => {
            this.messages[chatId] = this.messages[chatId] ?? [];
        };

        socket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (Array.isArray(data)) {
                this.messages[chatId] = uniqBy([
                    ...this.messages[chatId].filter((message) => !message.isLocal),
                    ...data.map((message) => ({
                        ...message,
                        sender: userId === message.sender_id ? 'user' : 'receiver'
                    }))
                ], 'id')
            } else if (isObject(data)) {
                this.messages[chatId] = [
                    ...this.messages[chatId],
                    {...data, sender: 'receiver'}
                ]
            }
            this.pendingMap[chatId] = false;
        };

        socket.onclose = (event) => {
            if (event.code === 1006) {
                delete this.sockets[chatId];
                this.connect({chatId, accessToken, userId})
            } else {
                delete this.sockets[chatId];
                delete this.messages[chatId];
                delete this.pendingMap[chatId];
            }
        };

        socket.onerror = (error) => {
            console.error(`Ошибка:`, error);
        };
    }

    closeAll = () => {
        Object.keys(this.sockets).forEach((chatId) => {
            if (!this.sockets[chatId]) return;
            this.sockets[chatId].close();
        })
    }
}

